import { withOverrideLegacy } from '~/App/hocs/with-override-legacy';

import { Block } from './Block';
import { loadData } from './Block.loadData';

export default withOverrideLegacy(Block, loadData);
